const BASE_URL = process.env.REACT_APP_BASE_URL;
const CLOUDINARY_URL = process.env.REACT_APP_CLOUDINARY_URL;

export { BASE_URL, CLOUDINARY_URL };
